export default {
  badge: 'Opsætning i gang',
  title: 'Gør din restaurant klar',
  description: 'Der mangler et par trin, før din restaurant kan gå live.',
  count: '{{done}} af {{total}} trin fuldført',
  cta: 'Fortsæt opsætning',
  done: {
    badge: 'Klar',
    title: 'Alt er klar',
    description: '{{partner}} sender din restaurant live.',
    fallback_partner: 'Din udbyder',
  },
};
